import { useEffect, useState } from "react";
import { fetchPCCAssignedHistory } from "../../apis/pccApi";
import { message } from "antd";

const PCCAssignedHistory = ({ pqrId }) => {
  const [assignedHistory, setAssignedHistory] = useState([]);

  useEffect(() => {
    const loadAssignedHistory = async () => {
      try {
        const res = await fetchPCCAssignedHistory(pqrId);
        setAssignedHistory(res.data);
      } catch {
        message.error("Error al cargar el historial de asignaciones");
      }
    };
    loadAssignedHistory();
  }, [pqrId]);

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Assigned History</h5>
        {assignedHistory.map((s) => (
          <div key={s.id} className="border-bottom py-2">
            <p className="mb-1">
              {s.previous_assigned_name} ➡ {s.new_assigned_name}
            </p>
            <small className="text-muted">
              By {s.changed_by_name} at {new Date(s.changed_at).toLocaleString()}
            </small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PCCAssignedHistory;
